// src/components/auth/LoginForm.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './AuthForms.css';

function LoginForm({ onLogin, onSwitchToRegister }) {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple validation
    const newErrors = {};
    if (!formData.email) newErrors.email = 'Email required';
    if (!formData.password) newErrors.password = 'Password required';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    try {
      console.log('Login attempt with:', formData);
      const result = await onLogin(formData);
      console.log('Login result:', result);
      if (!result.success) {
        setErrors({ form: result.error || 'Login failed' });
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrors({ form: 'An error occurred' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form-container">
      <h2>Sign in</h2>

      <form className="auth-form" onSubmit={handleSubmit}>
        {errors.form && <div className="form-error">{errors.form}</div>}

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="your@email.com"
            className={errors.email ? 'error' : ''}
          />
          {errors.email && <div className="input-error">{errors.email}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Your password"
            className={errors.password ? 'error' : ''}
          />
          {errors.password && <div className="input-error">{errors.password}</div>}
        </div>

        <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="rememberMe"
              checked={formData.rememberMe}
              onChange={handleChange}
            />
            <span>Keep me signed in</span>
          </label>

          <Link
            to="/forgot-password"
            style={{
              fontSize: '14px',
              color: '#058AE9',
              textDecoration: 'none',
              fontWeight: '500'
            }}
          >
            Forgot password?
          </Link>
        </div>

        <button
          type="submit"
          className="auth-button"
          disabled={loading}
        >
          {loading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>

      <div className="auth-switch">
        Not yet a member ? <button onClick={onSwitchToRegister}>Create an account</button>
      </div>
    </div>
  );
}

export default LoginForm;
